import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Shown when the session could not be established.
 *
 * Deliberately plain: it renders inside the host portal, which already draws its
 * own chrome around us, and it must not offer a "sign in" action — the portal owns
 * the login, and the fix for a failed exchange is to reload the portal's page.
 */
@Component({
  selector: 'error-page',
  standalone: true,
  imports: [],
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent {}
